export const REQUIRED_LIGHTING = {
  NONE: "none",
  ADAPTIVE: "adaptive",
  DEFAULT: "default",
} as const
export type RequiredLighting = (typeof REQUIRED_LIGHTING)[keyof typeof REQUIRED_LIGHTING]

export const PRESET = {
  FACE: "face",
  FACE_180: "face-180",
  HAIR: "hair",
} as const
export type Preset = (typeof PRESET)[keyof typeof PRESET]
